import * as React from 'react';

const MyAccountLayout = ({ children  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "myaccount-layout myaccount-layout--center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "site-container"
    }, children));
};
var MyAccountLayout$1 = MyAccountLayout;

export { MyAccountLayout$1 as default };
//# sourceMappingURL=MyAccountLayout.js.map
